import { Component } from 'react'
import { RouterProps, withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { generateKey } from '../../../../insfrastructure/utils/array-key'
import PersonalForm from './components/personal-form'
import Scholarships from './components/scholarship-form'
import ExperienceForm from './components/experience-form'
import JobTitleInterestsForm from './components/job-title-interests-form'
import SavedJobs from './components/saved-jobs'
import Skills from './components/skills'
import { retrieveCandidate } from '../../../../insfrastructure/services/candidates'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { getAuthToken } from '../../../../insfrastructure/services/token-manager'
import personImg from '../../../../assets/images/candidate-profile-options/person.svg'
import scholarshipImg from '../../../../assets/images/candidate-profile-options/scholarship.svg'
import experienceImg from '../../../../assets/images/candidate-profile-options/experience.svg'
import jobTitlesInterestsImg from '../../../../assets/images/candidate-profile-options/job-titles-interests.svg'
import subscriptionsImg from '../../../../assets/images/candidate-profile-options/subscriptions.svg'
import savedIcon from '../../../../assets/icons/saved-grey.svg'
import badgeIcon from '../../../../assets/icons/badge.svg'
import peopleIcon from '../../../../assets/icons/people.svg'
import personBlueImg from '../../../../assets/images/candidate-profile-options/person-blue.svg'
import scholarshipBlueImg from '../../../../assets/images/candidate-profile-options/scholarship-blue.svg'
import experienceBlueImg from '../../../../assets/images/candidate-profile-options/experience-blue.svg'
import jobTitlesInterestsBlueImg from '../../../../assets/images/candidate-profile-options/job-titles-interests-blue.svg'
import subscriptionsBlueImg from '../../../../assets/images/candidate-profile-options/subscriptions-blue.svg'
import badgeBlueIcon from '../../../../assets/icons/badge-blue.svg'
import peopleBlueIcon from '../../../../assets/icons/people-blue.svg'
import savedBlueIcon from '../../../../assets/icons/saved-blue-outlined.svg'
import './styles.sass'

class CandidateProfile extends Component<RouterProps> {
    state = {
        selectedPage: 'person',
        candidateProfile: null,
        loading: true
    }

    getPages = () => {
        
        return [
            {
                name: 'person',
                link: '',
                icon: personImg,
                selected_icon: personBlueImg,
                component: <PersonalForm 
                    candidateProfile={this.state.candidateProfile} 
                    onProfileUpdate={this.updateProfile}
                    loading={this.state.loading}
                />
            },
            {
                name: 'scholarship',
                link: '',
                icon: scholarshipImg,
                selected_icon: scholarshipBlueImg,
                component: <Scholarships />
            },
            {
                name: 'experience',
                link: '',
                icon: experienceImg,
                selected_icon: experienceBlueImg,
                component: <ExperienceForm 
                    candidateProfile={this.state.candidateProfile}
                    onProfileUpdate={this.updateProfile}
                />
            },
            {
                name: 'interests',
                link: '',
                icon: jobTitlesInterestsImg,
                selected_icon: jobTitlesInterestsBlueImg,
                component: <JobTitleInterestsForm />
            },
            {
                name: 'subscriptions',
                link: '',
                icon: savedIcon,
                selected_icon: savedBlueIcon,
                component: <SavedJobs />
            },
            {
                name: 'hard-skills',
                link: '',
                icon: badgeIcon,
                selected_icon: badgeBlueIcon,
                component: <Skills 
                    skill_category='Hard' 
                    candidateProfile={this.state.candidateProfile}
                    onProfileUpdate={this.updateProfile}
                />
            },
            {
                name: 'soft-skills',
                link: '',
                icon: peopleIcon,
                selected_icon: peopleBlueIcon,
                component: <Skills 
                    skill_category='Soft' 
                    candidateProfile={this.state.candidateProfile}
                    onProfileUpdate={this.updateProfile}
                />
            }
        ];
    }

    componentDidMount() {
        // Bloqueio temporário: em_job_manager não pode acessar o perfil até ter seu próprio perfil
        const token = getAuthToken();
        if (token) {
            const parsedJWT = parseJwt(token);
            if (parsedJWT?.profiles?.includes('em_job_manager')) {
                this.props.navigate('/offers/panel');
                return;
            }
        }
        
        this.changeCurrentPage();
        this.loadCandidateProfile();
    }

    loadCandidateProfile = async () => {
        try {
            const profile = await retrieveCandidate();
            this.setState({ candidateProfile: profile, loading: false });
        } catch (error) {
            this.setState({ loading: false });
        }
    }

    updateProfile = (updatedProfile: any) => {
        this.setState({ candidateProfile: updatedProfile });
    }

    componentDidUpdate(prevProps: Readonly<RouterProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if(prevProps.params !== this.props.params) {
            this.changeCurrentPage();
        };
    }

    changeCurrentPage() {
        if (this.props.params?.section) {
            this.setState({ selectedPage: this.props.params?.section });
        } else {
            setTimeout(() => {
                this.props.navigate('/profile/candidate/person');   
            });
        };
    }

    onSelectPage(name: string) {
        this.props.navigate('/profile/candidate/'+name);
    }

    render() {
        const pages = this.getPages();
        
        return (
            <div className='candidate-profile'>
                <div className='content'>
                    <div className='container'>
                        <div className='side-menu'>
                            <ul>
                                {
                                    pages.map(x =>
                                    <li key={generateKey(x.name)} onClick={() => this.onSelectPage(x.name)} className={this.state.selectedPage === x.name ? 'selected' : ''}>
                                        <img src={this.state.selectedPage !== x.name ? x.icon : x.selected_icon} alt={x.name} />
                                    </li>)
                                }
                            </ul>
                        </div>
                        <div className='block'>
                            {
                                pages.find(x => x.name === this.state.selectedPage)?.component || null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CandidateProfile)